export const DID_SEE_PANEL_COOKIE_KEY =
  'wt_paid-transfers-alpha_buyer-survey_panel-seen';

export const SURVEY_URL = 'https://we-transfer.typeform.com/to/JLmLUpXi';

export const PAID_TRANSFERS_ALPHA_BUYER_SURVEY_ROUTE =
  '/paid-transfers-buyer-survey';
